/**
 * 워크벤치 재실행 시 `기본이름 #N` 패턴에서 N을 하나 올린 표시 이름을 만듭니다.
 * (예: equipment-monitoring #1 → equipment-monitoring #2)
 */
export function bumpRunIterationDisplayName(name: string): string {
  const trimmed = name.trim();
  const m = trimmed.match(/^(.*)( #(\d+))$/);

  if (m) {
    const n = Number(m[3]);
    if (Number.isFinite(n) && n >= 0) {
      return `${m[1]} #${n + 1}`;
    }
  }

  return `${trimmed || name} #2`;
}
